import { EditLancementPage } from "@features/production/components/EditLancementPage";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { FileEdit } from "lucide-react";

export const Route = createFileRoute("/_app/production/lancements/$id/edit")({
  loader: requirePermission(PERMISSIONS.PRODUCTION.LANCEMENTS.EDIT),
  staticData: {
    title: "Modifier lancement",
    icon: FileEdit,
    permission: PERMISSIONS.PRODUCTION.LANCEMENTS.EDIT,
    section: "App",
    showInBreadcrumb: true,
  },
  component: EditLancementPage,
});
